import React, { useEffect, useState } from 'react';
import PlaylistItem from '../PlayListItem/PlaylistItem';

const Playlist = () => {

    const[Playlist, setPlaylist] = useState([])
    useEffect(() =>{
        fetch(
          `https://youtube.googleapis.com/youtube/v3/playlists?part=snippet&channelId=UC49igY3A_M9__UL4_QUWTBA&maxResults=50&key=${process.env.REACT_APP_apiKey_alter}`
        )
          .then((res) => res.json())
          .then((data) => setPlaylist(data?.items));
      },[])

    return (
      <>
        <h1 className=" flex md:inset-y-40 text-black justify-center font-bold text-2xl md:text-5xl italic  mb-3">
          Playlists
        </h1>
        <div className="flex flex-wrap justify-center gap-3 max-w-[90%] mx-auto p-3 rounded-xl">
          {Playlist?.map((singlePlaylist) => (
            <PlaylistItem
              key={singlePlaylist?.snippet?.thumbnails?.medium?.url}
              list={singlePlaylist}
            ></PlaylistItem>
          ))}
        </div>
      </>
    );
};

export default Playlist;